/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { vappContainer } from '@/application';
import { MarriageExemptiConfig } from './../../config/marriageExemption.config';
import {workPermitConfig} from './../../config/workPermit.config';
import { AppNavigatorService } from '@/AppNavigator';
const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

export interface IFetchDocumentsMethods extends IPluginMethodMap {
  FetchDocuments(args: any): Promise<any>;
}

export interface FetchDocumentsProps {}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export class FetchDocumentsService implements IAgentPlugin {
  readonly methods: IFetchDocumentsMethods;

  constructor() {
    this.methods = {
      FetchDocuments: this.FetchDocuments.bind(this),
    };
  }
  private fetchcl = async (src: any) => {
    const token = loginSrv()?.getToken();
    try {
      const response = await axios.get(src, {
        headers: {
          'Content-Type': 'application/json',
          Authentication: `${token}`,
        },
        responseType: 'arraybuffer',
      });

      const data = response.data;

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(new Blob([data]));
        reader.onload = () => {
          const res = reader.result + '';
          console.log('final_initdata', res);
          resolve(res);
        };
        reader.onerror = (error) => reject(error);
      });
    } catch (error) {
      console.error('Error:', error);
      // Handle error
    }
  };
  async FetchDocuments(totdata: any) {
    const data=totdata?.documents ?? [];
    console.log(`service input data-->fetchdocs`, totdata);
    if(totdata?.type==="MARRIAGE_EXEMPTION" || totdata?.type==="RENEW_MARRIAGE_EXEMPTION"){
    try {
      console.log('entered...');
      let _documents: any = {};
      await Promise.all(
        Object.entries(MarriageExemptiConfig?.availableDocuments).map(
          async (ele) => {
            let _similarDoc: any[] = [];
            await Promise.all(
              data && Array.isArray(data) && data?.length>0 ? data?.map(async (doc: any) => {
                if (doc?.type === ele[1]) {
                  _similarDoc.push({
                    name: doc?.name,
                    src: await this.fetchcl(doc?.src),
                    type: doc?.fileType,
                  });
                }
              }):[]
            );
            _documents[ele[0]] = _similarDoc;
          }
        )
      );
      console.log(
        'draftedappsttaaerechange formatAppDraft getDocuments ',
        _documents
      );
      return _documents;
    } catch (err) {
      console.log('formatAppDraft getDocuments error', err);
      throw err;
    }
    }
    else{
        let docss : any = {nolGender: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolSports: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMusic: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMedia: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    graduateQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    nurseQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    associateDegreeQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    teacherQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE'}
    let docData: any = {...workPermitConfig?.availableDocuments,...docss};
    try {
        console.log('entered...',docData);
        let _documents: any = {};
        await Promise.all(
          Object.entries(docData).map(
            async (ele) => {
              let _similarDoc: any[] = [];
              await Promise.all(
                data && Array.isArray(data) && data?.length>0 ? data?.map(async (doc: any) => {
                  if (doc?.type === ele[1]) {
                    _similarDoc.push({
                      name: doc?.name,
                      src: await this.fetchcl(doc?.src),
                      type: doc?.fileType,
                    });
                  }
                }):[]
              );
              _documents[ele[0]] = _similarDoc;
            }
          )
        );
        console.log(
          'draftedappsttaaerechange formatAppDraft getDocuments ',
          _documents
        );
        return _documents;
      } catch (err) {
        console.log('formatAppDraft getDocuments error', err);
        throw err;
      }
    }
  }
}
